<script setup>
import { ref } from "vue";
import { router, usePage } from "@inertiajs/vue3";
import { useModalogStore } from "@/stores/modalog";
import { useToastStore } from "@/stores/toast.js";
import BrandConfirmModalog from "@/Components/Modalogs/BrandConfirmModalog.vue";

const modalogStore = useModalogStore();
const toastStore = useToastStore();

const props = defineProps({
    item: {
        type: Object,
        default: () => ({}),
    },
    redirectUrl: {
        type: String,
        default: null,
    },
});

const deleting = ref(false);

function deleteItem() {
    deleting.value = true;

    axios
        .delete(route("item.delete", { item: props.item.uuid }))
        .then(() => {
            if (props.redirectUrl) {
                // Full page load ahead — park the toast for the next mount.
                toastStore.flashNext(
                    "success",
                    `"${props.item.name}" was deleted.`,
                );
                window.location = props.redirectUrl;

                return;
            }

            toastStore.success(`"${props.item.name}" was deleted.`);

            if (usePage().component === "Shared/ItemDetail") {
                router.visit(
                    route("list.show", {
                        giftlist: usePage().props.giftlist.data.uuid,
                    }),
                );
            } else {
                router.reload({ only: ["items"] });
            }
        })
        .catch((error) => console.error(error))
        .finally(() => {
            modalogStore.closeModalog();
            deleting.value = false;
        });
}
</script>

<template>
    <BrandConfirmModalog
        title="Delete Item"
        confirm-label="Delete"
        busy-label="Deleting"
        danger
        :busy="deleting"
        @confirm="deleteItem"
    >
        <p>
            Are you sure you want to delete
            <strong>{{ props.item.name }}</strong> from your wish list?
        </p>
    </BrandConfirmModalog>
</template>
